module.exports = __webpack_public_path__ + "static/media/link-external-icon.16de3c44.svg";